
import star from "../../assets/images/accessories/icon-star.png"
import darkStar from "../../assets/images/accessories/icon-dark-star.png"
import halfStar from "../../assets/images/accessories/icon-half-star.png"

export const listBrand=[
    {
        id:1,
        name:'apple',
        url:'https://cdn.tgdd.vn/Brand/1/Apple482-b_37.jpg'
    },
    {
        id:2,
        name:'beats',
        url:'https://cdn.tgdd.vn/Brand/1/Beats482-b_28.jpg'
    },
    {
        id:3,
        name:'harman',
        url:'https://cdn.tgdd.vn/Brand/1/Harman-Kardon482-b_23.jpg'
    },
    {
        id:4,
        name:'samsung',
        url:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-220x48-1.png'
    },
    {
        id:5,
        name:'sony',
        url:'https://cdn.tgdd.vn/Brand/1/Sony482-b_41.jpg'
    },
    {
        id:6,
        name:'belkin',
        url:'https://cdn.tgdd.vn/Brand/1/Belkin9499-s39-160x40.jpg'
    },
    {
        id:7,
        name:'anker',
        url:'https://cdn.tgdd.vn/Brand/1/Anker482-b_18.png'
    },
    {
        id:8,
        name:'logitech',
        url:'https://cdn.tgdd.vn/Brand/1/Logitech482-b_47.jpg'
    },
    {
        id:9,
        name:'jbl',
        url:'https://cdn.tgdd.vn/Brand/1/JBL-220x48-1.jpeg'
    },
    {
        id:10,
        name:'xiaomi',
        url:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14-220x48.png'
    },
    {
        id:11,
        name:'lg',
        url:'https://cdn.tgdd.vn/Brand/1/LG482-b_17.png'
    },
    {
        id:12,
        name:'asus',
        url:'https://cdn.tgdd.vn/Brand/1/Asus482-b_26.png'
    },
    {
        id:13,
        name:'jabra',
        url:'https://cdn.tgdd.vn/Brand/1/Jabra482-b_45.jpg'
    },
    {
        id:14,
        name:'oppo',
        url:'https://cdn.tgdd.vn/Brand/1/OPPO42-b5-220x48-6.jpg'
    },
    {
        id:15,
        name:'lg',
        url:'https://cdn.tgdd.vn/Brand/1/Mophie482-b_19.jpg'
    },
    {
        id:16,
        name:'microsoft',
        url:'https://cdn.tgdd.vn/Brand/1/Microsoft482-b_26.jpg'
    },
    {
        id:17,
        name:'corsair',
        url:'https://cdn.tgdd.vn/Brand/1/Corsair482-b_12.jpg'
    },
    {
        id:18,
        name:'philips',
        url:'https://cdn.tgdd.vn/Brand/1/Philips482-b_58.png'
    },
    {
        id:19,
        name:'genius',
        url:'https://cdn.tgdd.vn/Brand/1/Genius482-b_59.jpg'
    },
    {
        id:20,
        name:'zadez',
        url:'https://cdn.tgdd.vn/Brand/1/Zadez482-b_59.jpg'
    }
]

export const listProductDeal = [
    {
        id:1,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        initialPrice: '5.490.000',
        discount: 12,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:1,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:1,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:1,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:1,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    }
]

// apple accessories
export const menuAppleAccessories = [
    {
        title: 'Nổi bật',
        cateId: 4,
        subCateId:0,
        manufactureId:1,
    },
    { 
        title:'Tai nghe',
        cateId: 4,
        subCateId:8,
        manufactureId:1,
    },
    {
        title:'Adapter sạc',
        cateId: 4,
        subCateId:6,
        manufactureId:1,
    },
    {
        title:'Cáp sạc',
        cateId: 4,
        subCateId:6,
        manufactureId:1,
    },
    {
        title:'Ốp lưng',
        cateId: 4,
        subCateId:7,
        manufactureId:1,
    },
]



export const listProductAppleAccessories = [
    {
        id:1,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online: 'Chỉ bán online',
        initialPrice: '5.490.000',
        discount: 12,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:2,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online: 'Online giá rẻ',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:3,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:4,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:5,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'Chỉ bán online',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:6,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:7,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:8,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:9,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    },
    {
        id:10,
        title:'Tai nghe Bluetooth AirPods 3 Apple MME73',
        online:'',
        initialPrice: '5.490.000',
        discount: 12,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/54/250701/airpods-3-hop-sac-khong-day-thumb-600x600.jpeg',
    }
]

// backup battery
export const menuBackupBattery = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Dung lượng 10000mAh',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Dung lượng 20000mAh',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Dưới 300.000đ',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Xmobile',
        cateId: 7,
        manufactureId:10,
    },    

]


export const menuHeadphone = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Bluetooth',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Apple',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Không dây True-Wireless',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Sony',
        cateId: 7,
        manufactureId:10,
    },    
    
]


export const menuCableCharge=[
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Cáp lightning',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Adapter sạc Type-C',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Adapter sạc USB',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Cáp Type-C',
        cateId: 7,
        manufactureId:10,
    },  
]


export const menuSpeaker=[
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Loa bluetooth',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'JBL',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Harman Kardon',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Sony',
        cateId: 7,
        manufactureId:10,
    },  
]



export const menuTech = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Khóa điện tử',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Ổ cắm thông minh',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'TV Box',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Router',
        cateId: 7,
        manufactureId:10,
    },  
]


export const menuGaming = [
    {
        title: 'Nổi bật',
        cateId: 5,
        manufactureId:10,
    },
    { 
        title:'Chuột',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Bàn phím',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Tai nghe',
        cateId: 7,
        manufactureId:10,
    },
    {
        title:'Webcam',
        cateId: 7,
        manufactureId:10,
    },  
]

export const menuTopFixed = [
    {
        title: 'Deal Sốc',
        name:'deal',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/dealsoc.png'
    },
    {
        title: 'Apple chính hãng',
        name:'apple',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/phu-kien-apple.png'
    },
    {
        title: 'Pin sạc dự phòng',
        name:'backupCharger',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/pinsac.png'
    },
    {
        title: 'Sạc, cáp',
        name:'chargeCable',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/capsac.png'
    },
    {
        title: 'Tai nghe',
        name:'headphone',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tainghe.png'
    },
    {
        title: 'Loa',
        name:'speaker',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/loa.png'
    },
    {
        title: 'Thiết bị nhà thông minh',
        name:'tech',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/thietbimang.png'
    },
    {
        title: 'Phụ kiện gaming',
        name:'gaming',
        url: 'https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/pk-gaming.png'
    },
   
]



export const groupCate = [
    {
        id:1,
        name: 'iphone',
        title:'Phụ Kiện Phone, Tablet',
        childCate:[
            {
            nameChild: 'Sạc dự phòng',
            link:'/sac-dtdd',
            imgUrl:'https://cdn.tgdd.vn/Category/57/5-Pinsa%CC%A3cdu%CC%9B%CC%A3pho%CC%80ng-100x100.png'
        },
            {
            nameChild: 'Sạc, cáp',
            link:'/sac-cap',
            imgUrl:'https://cdn.tgdd.vn/Category/9518/10-Ca%CC%81psa%CC%A3cchuye%CC%82%CC%89ndo%CC%82%CC%89i-100x100.png'
        },
            {
            nameChild: 'Ốp lưng đ.thoại',
            link:'/op-lung-flipcover',
            imgUrl:'https://cdn.tgdd.vn/Category/60/2-O%CC%82%CC%81plu%CC%9Bngdie%CC%A3%CC%82nthoa%CC%A3i-100x100.png'
        },
        {
            nameChild: 'Ốp lưng tablet',
            imgUrl:'https://cdn.tgdd.vn/Category/1662/6-O%CC%82%CC%81plu%CC%9Bngtablet-100x100.png'
        },
            {
            nameChild: 'Airtag',
            imgUrl:'https://cdn.tgdd.vn/Category/10618/airtag-100x100.png'
        },
            {
            nameChild: 'Thẻ nhớ',
            imgUrl:'https://cdn.tgdd.vn/Category/55/3-the%CC%89nho%CC%9B%CC%81-100x100.png'
        },
            {
            nameChild: 'Dán màn hình',
            imgUrl:'https://cdn.tgdd.vn/Category/1363/da%CC%81nma%CC%80nhi%CC%80nh-60x60-2.png'
        },
            {
            nameChild: 'Phụ kiện tablet',
            imgUrl:'https://cdn.tgdd.vn/Category/1882/7-Phu%CC%A3kie%CC%A3%CC%82ntablet-100x100.png'
        },
            {
            nameChild: 'Giá đỡ đ.thoại, laptop',
            imgUrl:'https://cdn.tgdd.vn/Category/6862/logogiadonew-100x100.png'
        },
            {
            nameChild: 'Gậy chụp ảnh, Gimbal',
            imgUrl:'https://cdn.tgdd.vn/Category/3885/4-Ga%CC%A3%CC%82ytu%CC%9B%CC%A3su%CC%9Bo%CC%9B%CC%81ng-100x100.png'
        },
            {
            nameChild: 'Túi chống nước',
            imgUrl:'https://cdn.tgdd.vn/Category/6859/8-Tu%CC%81icho%CC%82%CC%81ngnu%CC%9Bo%CC%9B%CC%81cdt-100x100.png'
        },
    ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-phone_2.png?v=3"
    },
    {
        id:2,
        name:'laptop',
        title:'Phụ Kiện Laptop, PC',
        childCate:[
            {
                nameChild:'Sạc, cáp',
                imgUrl:'https://cdn.tgdd.vn/Category/9518/10-Ca%CC%81psa%CC%A3cchuye%CC%82%CC%89ndo%CC%82%CC%89i-100x100.png'
            },
            {
                nameChild:'Adapter sạc, chuyển đổi',
                imgUrl:'https://cdn.tgdd.vn/Category/9499/publicpreview(1)-100x100.png'
            },
            {
                nameChild:'Chuột máy tính',
                link:'/chuot-ban-phim',
                imgUrl:'https://cdn.tgdd.vn/Category/86/13-Chuo%CC%A3%CC%82tma%CC%81yti%CC%81nh-100x100.png'
            },
            {
                nameChild:'Bàn phím',
                imgUrl:'https://cdn.tgdd.vn/Category/4547/19-Ba%CC%80nphi%CC%81m-100x100.png'
            },
            {
                nameChild:'USB',
                imgUrl:'https://cdn.tgdd.vn/Category/75/14-Usb-100x100.png'
            },
            {
                nameChild:'Ổ cứng di động',
                imgUrl:'https://cdn.tgdd.vn/Category/1902/20-O%CC%82%CC%89cu%CC%9B%CC%81ngdido%CC%A3%CC%82ng-100x100.png'
            },
            {
                nameChild:'Balo, túi chống sốc',
                imgUrl:'https://cdn.tgdd.vn/Category/7923/15-Balotu%CC%81icho%CC%82%CC%81ngso%CC%82%CC%81c-100x100.png'
            },
            {
                nameChild: 'Giá đỡ đ.thoại, laptop',
                imgUrl:'https://cdn.tgdd.vn/Category/6862/logogiadonew-100x100.png'
            },
            {
                nameChild:'Phần mềm',
                imgUrl:'https://cdn.tgdd.vn/Category/85/18-Pha%CC%82%CC%80nme%CC%82%CC%80m-100x100.png'
            },
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-lap_2.png?v=3"
    },
    {
        id:3,
        name:'headphone',
        title:'Thiết bị Âm thanh',
        childCate:[
            {
                nameChild:'Loa',
                link:'/loa-laptop',
                imgUrl:'https://cdn.tgdd.vn/Category/2162/22-Loa1-100x100.png'
            },
            {
                nameChild:'Tai nghe',
                link:'/tai-nghe',
                imgUrl:'https://cdn.tgdd.vn/Category/54/21-Tainghe-100x100.png'
            },
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-amthanh_2.png?v=3"
    },
    {
        id:4,
        name:'tech',
        title:'Phụ Kiện Công nghệ',
        childCate:[
            {
                nameChild:'Thiết bị mạng',
                imgUrl:'https://cdn.tgdd.vn/Category/4727/16-Thie%CC%82%CC%81tbi%CC%A3ma%CC%A3ng-100x100.png'
            },
            {
                nameChild:'Thiết bi nhà thông minh',
                imgUrl:'https://cdn.tgdd.vn/Category/9458/thongminh-100x100.png'
            },
            {
                nameChild:'Camera, Webcam',
                imgUrl:'https://cdn.tgdd.vn/Category/4728/17-Camerawebcam-100x100.png'
            },
            {
                nameChild:'Khóa điện tử',
                link:'/khoa-dien-tu',
                imgUrl:'https://cdn.tgdd.vn/Category/10001/hafele-el9000-01-100x100.png'
            },
            {
                nameChild:'TV Box',
                imgUrl:'https://cdn.tgdd.vn/Category/9118/23-TVBox-100x100.png'
            },
            {
                nameChild:'Ổ cắm, bóng đèn thông minh',
                imgUrl:'https://cdn.tgdd.vn/Category/10871/logocateocam-100x100.png'
            },
            {
                nameChild:'Máy chiếu',
                imgUrl:'https://cdn.tgdd.vn/Category/862/logocatemaychieu-100x100.jpg'
            },
            {
                nameChild:'Phụ kiện ô tô',
                imgUrl:'https://cdn.tgdd.vn/Category/9041/28-Phu%CC%A3kie%CC%A3%CC%82no%CC%82to%CC%82-100x100.png'
            },
            {
                nameChild:'Máy tính cầm tay',
                imgUrl:'https://cdn.tgdd.vn/Category/9398/25-Ma%CC%81yti%CC%81nhca%CC%82%CC%80mtay-100x100.png'
            },
            {
                nameChild:'Túi đựng AirPods',
                imgUrl:'https://cdn.tgdd.vn/Category/7925/30-Tu%CC%81idu%CC%9B%CC%A3ngAirpod-100x100.png'
            },
            {
                nameChild:'Quạt mini',
                imgUrl:'https://cdn.tgdd.vn/Category/7922/29-Qua%CC%A3tmini-100x100.png'
            },
            {
                nameChild:'Pin tiểu',
                imgUrl:'https://cdn.tgdd.vn/Category/56/26-Pintie%CC%82%CC%89upindt-100x100.png'
            },
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-congnghe_2.png?v=3"
    },
    {
        id:5,
        name:'gaming',
        title:'Phụ Kiện Gaming',
        childCate:[
            ''
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-gaming_2.png?v=3"
    }
 
]

export const list_box_filter_sac_dung_phong = [
    {
        id:1,
        title: 'Hãng',
        name:'brands',
        dropDown: [
            {
                id:1,
                img:'https://cdn.tgdd.vn/Brand/1/Apple7077-b26-220x48.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:2,
                img:'https://cdn.tgdd.vn/Brand/1/samsungnew-220x48-5.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:3,
                img:'https://cdn.tgdd.vn/Brand/1/logo-xiaomi-220x48-14.png',
                subCateId:1,
                manufactureId:3,
            },
            {
                id:4,
                img:'https://cdn.tgdd.vn/Brand/1/Garmin7077-b_13.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:5,
                img:'https://cdn.tgdd.vn/Brand/1/logo-befit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:6,
                img:'https://cdn.tgdd.vn/Brand/1/logoamazfit-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:7,
                img:'https://cdn.tgdd.vn/Brand/1/Kidcare7077-b_5.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:8,
                img:'https://cdn.tgdd.vn/Brand/1/Masstel7077-b_57.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:9,
                img:'https://cdn.tgdd.vn/Brand/1/Oppo7077-b_28.jpg',
                subCateId:1,
                manufactureId:4,
            },
            {
                id:10,
                img:'https://cdn.tgdd.vn/Brand/1/Realme7077-b_28.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:11,
                img:'https://cdn.tgdd.vn/Brand/1/Abardeen7077-b_25.jpg',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:12,
                img:'https://cdn.tgdd.vn/Brand/1/Suunto7077-b_14.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:13,
                img:'https://cdn.tgdd.vn/Brand/1/logo-asus-149x40-11.png',
                subCateId:1,
                manufactureId:2,
            },
            {
                id:14,
                img:'https://cdn.tgdd.vn/Brand/1/itellogo-220x48-1.png',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:2,
        title: 'Dung lượng pin',
        name:'drop-left pin',
        dropDown: [
            {   
                name:'pin',
                content:'Dưới 10.000mAh',
                subCateId:1,
                manufactureId:2,
            },
            {
                name:'pin',
                content:'10.000mAh',
                subCateId:1,
                manufactureId:2,
            },
            {
                name:'pin',
                content:'15.000mAh',
                subCateId:1,
                manufactureId:2,
            },
            {
                name:'pin',
                content:'20.000mAh',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:3,
        title: 'Giá',
        name:'drop-left price',
        dropDown: [
            {
                content:'Dưới 300.000đ trăm',
                maxPrice:300000,
                minPrice:0
            },
            {
                content:'Từ 300.000đ - 500.000đ',
                maxPrice:500000,
                minPrice:300000
            },
            {
                content:'Từ 500.000đ - 700.000đ',
                maxPrice:700000,
                minPrice:500000
            },
            {
                content:'Trên 700.000đ',
                maxPrice:700000,
                minPrice:700000
            },
        ],
    },
    
    {
        id:4,
        title: 'Công suất',
        name:'drop-left pow',
        dropDown: [
            {
                content:'10W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'10.5W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'12W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'13W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'15W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'18W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'20W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'22.5W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'25W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
            {
                content:'30W',
                subCateId:1,
                manufactureId:2,
                idDropDown: 4,
                
            },
        ],
    },
    {
        id:5,
        title: 'Tiện ích',
        name:'drop-left utility',
        dropDown: [
            {
                content:'Sạc Magsafe',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Sạc nhanh',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Sạc không dây',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Tự điều chỉnh dòng',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:6,
        title: 'Thiết kế',
        name:'drop-left design',
        dropDown: [
            {
                content:'Nhỏ gọn',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Siêu mỏng',
                subCateId:1,
                manufactureId:2,
            },
            {
                content:'Họa tiết dễ thương',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
    {
        id:7,
        title: 'Cổng sạc',
        name:'charge',
        dropDown: [
            {
                name:'chargeDrop',
                content:'Type-C',
                subCateId:1,
                manufactureId:2,
            },
            {
                name:'chargeDrop',
                content:'Lightning',
                subCateId:1,
                manufactureId:2,
            },
            {
                name:'chargeDrop',
                content:'Micro USB',
                subCateId:1,
                manufactureId:2,
            },
            {
                name:'chargeDrop',
                content:'USB',
                subCateId:1,
                manufactureId:2,
            },
        ],
    },
]

export const box_filter = [
    {
        content:'Bán chạy',
        value:'',
    },
    {
        content:'% Giảm',
        value:'',
    },
    {
        content:'Giá cao đến thấp',
        value:'decrease',
    },
    {
        content:'Giá thấp đến cao',
        value:'increase',
    }
]

